/* ============================================================
   Bondi Bark - Water Fountain Sales Page
   ------------------------------------------------------------
   Interactive behaviour:
   - Accordion (PDP + FAQ)
   - Variant toggle (Wired / Wireless)
   - Bundle selector (1m / 6m / 1y) + dynamic CTA price
   - Gallery thumbnail switch
   - Sticky mobile ATC reveal on scroll past primary CTA

   Implementation:
   - Pure event delegation on document. No per-element listeners.
   - Survives Theme Editor re-renders and dynamic section loads.
   - No null bytes (Shopify minifier rejects them).
   ============================================================ */
(function () {
  if (window.__fountainPageInit) return;
  window.__fountainPageInit = true;

  // ---- Reset cart when returning from checkout ----
  // If the user is coming back from a Shopify checkout (any of the standard URL
  // patterns), wipe the cart so the drawer doesn't auto-open with stale items
  // and the customer starts a fresh selection.
  (function () {
    try {
      var ref = document.referrer || '';
      if (!ref) return;
      var fromCheckout =
        /\/checkouts?\//i.test(ref) ||                          // /checkout/...  or /checkouts/...
        /^https?:\/\/checkout\./i.test(ref) ||                   // checkout.<shop>.com (Shopify Plus)
        /shopify\.com\/.*checkouts?\//i.test(ref) ||             // ...shopify.com/.../checkouts/...
        /\/thank[_-]you/i.test(ref);                             // /thank_you or /thank-you
      if (!fromCheckout) return;
      // Silent clear — POST /cart/clear.js. UPCART will see an empty cart and not auto-open.
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (err) { /* never throw on init */ }
  })();


  // ---- Accordion ----
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.fountain-scope .fountain-acc-head');
    if (head) {
      var item = head.closest('.fountain-acc-item');
      if (item) {
        var isOpen = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
  });

  // ---- Helpers: dynamic total = bundle + checked add-ons ----
  function fountainParsePrice(str) {
    if (!str) return 0;
    // Match the first number (handles "$254", "$44.25", "AUD 254" etc.)
    var m = String(str).match(/[\d]+(?:\.[\d]+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  function fountainFormatPrice(num, sample) {
    // Match the sample's currency prefix (e.g., "$" from "$254"). Default to "$".
    var prefix = '$';
    if (sample) {
      var pm = String(sample).match(/^[^\d-]+/);
      if (pm) prefix = pm[0];
    }
    // Drop trailing .00 — show "$254" not "$254.00"; keep cents otherwise.
    var s = (Math.round(num * 100) / 100).toFixed(2).replace(/\.00$/, '');
    return prefix + s;
  }

  function fountainComputeTotal(pdp) {
    if (!pdp) return null;
    // Active bundle: visible set, is-selected
    var visibleSet = pdp.querySelector('[data-fountain-bundles]:not([hidden])');
    if (!visibleSet) return null;
    var selected = visibleSet.querySelector('[data-fountain-bundle].is-selected')
                || visibleSet.querySelector('[data-fountain-bundle]');
    if (!selected) return null;
    var sample = selected.getAttribute('data-price') || '$0';
    var tier = selected.getAttribute('data-tier') || '';
    var total = fountainParsePrice(sample);

    pdp.querySelectorAll('[data-fountain-addon-checkbox]').forEach(function (cb) {
      if (!cb.checked) return;
      var label = cb.closest('.fountain-addon');
      if (!label) return;

      // Determine if this addon is free under the current tier
      var freeTiers = (label.getAttribute('data-fountain-addon-free-tiers') || '')
        .split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var defaultFree = label.getAttribute('data-fountain-addon-price-free') || '';
      var isFreeByTier = freeTiers.length > 0 && freeTiers.indexOf(tier) >= 0;
      var isAlwaysFree = freeTiers.length === 0 && defaultFree !== '';
      if (isFreeByTier || isAlwaysFree) return; // contributes 0

      // Otherwise add its "now" price
      var nowStr = label.getAttribute('data-fountain-addon-price-now') || '';
      total += fountainParsePrice(nowStr);
    });

    return { total: total, sample: sample };
  }

  function fountainUpdateTotal(pdp) {
    var r = fountainComputeTotal(pdp);
    if (!r) return;
    var formatted = fountainFormatPrice(r.total, r.sample);
    var ctaPrice = pdp.querySelector('[data-fountain-cta-price]');
    if (ctaPrice) ctaPrice.textContent = formatted;
    var stickyPrice = document.querySelector('[data-fountain-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatted;
  }

  // ---- Sync variant toggle (Wired/Wireless) to the currently visible bundle set ----
  function fountainSyncVariantToggle(pdp) {
    if (!pdp) return;
    var visibleSet = pdp.querySelector('[data-fountain-bundles]:not([hidden])');
    if (!visibleSet) return;
    var power = visibleSet.getAttribute('data-fountain-bundles') || '';
    pdp.querySelectorAll('[data-fountain-power]').forEach(function (b) {
      var match = b.getAttribute('data-fountain-power') === power;
      if (match) {
        b.classList.add('is-active');
        b.setAttribute('aria-selected', 'true');
      } else {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      }
    });
  }

  // ---- Bundle selection (delegated) ----
  document.addEventListener('click', function (e) {
    var bundle = e.target.closest('.fountain-scope [data-fountain-bundle]');
    if (!bundle) return;
    var set = bundle.closest('[data-fountain-bundles]');
    if (!set) return;
    var pdp = bundle.closest('[data-fountain-pdp]') || bundle.closest('.fountain-scope');
    if (!pdp) return;

    // Toggle selected within this set only
    set.querySelectorAll('[data-fountain-bundle]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    bundle.classList.add('is-selected');

    // Sync form variant id
    var vid = bundle.getAttribute('data-variant-id');
    var variantInput = pdp.querySelector('[data-fountain-variant-input]');
    if (vid && variantInput) variantInput.value = vid;

    // Quantity always 1 (the variant IS the bundle)
    var qtyInput = pdp.querySelector('[data-fountain-qty-input]');
    if (qtyInput) qtyInput.value = '1';

    // Sync CTA price + sticky CTA price
    var price = bundle.getAttribute('data-price');
    var was = bundle.getAttribute('data-price-was');
    var ctaPriceEl = pdp.querySelector('[data-fountain-cta-price]');
    var stickyPriceEl = document.querySelector('[data-fountain-sticky-price]');
    var stickyWasEl = document.querySelector('[data-fountain-sticky-was]');
    if (ctaPriceEl && price) ctaPriceEl.textContent = price;
    if (stickyPriceEl && price) stickyPriceEl.textContent = price;
    if (stickyWasEl) stickyWasEl.textContent = was || '';

    // Enable CTA if it was disabled
    var cta = pdp.querySelector('[data-fountain-cta]');
    if (cta) {
      cta.removeAttribute('disabled');
      cta.classList.remove('is-disabled');
    }

    // Variant-conditional addon pricing: re-render each addon's price slot
    // based on the just-selected bundle's tier (1m / 6m / 1y).
    var tier = bundle.getAttribute('data-tier') || '';
    pdp.querySelectorAll('.fountain-addon').forEach(function (addon) {
      var slot = addon.querySelector('[data-fountain-addon-price-slot]');
      if (!slot) return;
      var freeTiers = (addon.getAttribute('data-fountain-addon-free-tiers') || '').split(',').map(function (t) { return t.trim(); });
      var freeText = addon.getAttribute('data-fountain-addon-free-text') || '';
      var priceNow = addon.getAttribute('data-fountain-addon-price-now') || '';
      var priceWas = addon.getAttribute('data-fountain-addon-price-was') || '';
      var defaultFree = addon.getAttribute('data-fountain-addon-price-free') || '';

      var shouldBeFree = freeTiers.indexOf(tier) >= 0;
      var html = '';
      if (shouldBeFree && freeText) {
        html = '<span class="fountain-addon__free">' + freeText + '</span>';
        if (priceWas) html += '<span class="fountain-addon__was">' + priceWas + '</span>';
      } else if (defaultFree) {
        // Default state is free (no tier-conditional)
        html = '<span class="fountain-addon__free">' + defaultFree + '</span>';
        if (priceWas) html += '<span class="fountain-addon__was">' + priceWas + '</span>';
      } else {
        if (priceNow) html += '<span class="fountain-addon__now">' + priceNow + '</span>';
        if (priceWas) html += '<span class="fountain-addon__was">' + priceWas + '</span>';
      }
      slot.innerHTML = html;
    });

    // Auto-tick/untick addons whose free_for_tiers matches the just-selected tier.
    // Two-way: tier in list → check; tier NOT in list → uncheck.
    // Example: Cleaning Kit (free_for_tiers="1y") auto-ticks on 1y, auto-unticks on 1m/6m.
    pdp.querySelectorAll('.fountain-addon').forEach(function (addon) {
      var freeTiers = (addon.getAttribute('data-fountain-addon-free-tiers') || '')
        .split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      if (freeTiers.length === 0) return; // not tier-gated → leave user's choice alone
      var cb = addon.querySelector('[data-fountain-addon-checkbox]');
      if (!cb) return;
      var shouldBeChecked = freeTiers.indexOf(tier) >= 0;
      if (cb.checked !== shouldBeChecked) {
        cb.checked = shouldBeChecked;
        // Dispatch change so total recomputes
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    fountainSyncVariantToggle(pdp);
    fountainUpdateTotal(pdp);
  });

  // ---- Variant toggle (Power: Wired / Wireless) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fountain-scope [data-fountain-power]');
    if (!btn) return;
    var pdp = btn.closest('[data-fountain-pdp]') || btn.closest('.fountain-scope');
    if (!pdp) return;
    var power = btn.getAttribute('data-fountain-power');

    // Update toggle state
    pdp.querySelectorAll('[data-fountain-power]').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected', 'true');

    // Show only the matching bundle set
    pdp.querySelectorAll('[data-fountain-bundles]').forEach(function (set) {
      var isMatch = set.getAttribute('data-fountain-bundles') === power;
      if (isMatch) set.removeAttribute('hidden');
      else set.setAttribute('hidden', '');
    });

    // Auto-select the 1 Month bundle in the newly visible set (user preference).
    // Falls back to --hero (6m) or the first bundle if 1m doesn't exist.
    var visible = pdp.querySelector('[data-fountain-bundles]:not([hidden])');
    if (visible) {
      var target = visible.querySelector('[data-fountain-bundle][data-tier="1m"]')
                || visible.querySelector('.fountain-bundle--hero')
                || visible.querySelector('[data-fountain-bundle]');
      if (target) target.click();
    }
  });

  // ---- Gallery thumb swap ----
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.fountain-scope [data-fountain-thumb]');
    if (!thumb) return;
    var pdp = thumb.closest('[data-fountain-pdp]') || thumb.closest('.fountain-scope');
    if (!pdp) return;
    var src = thumb.getAttribute('data-src');
    var alt = thumb.getAttribute('data-alt') || '';
    if (!src) return;
    var mainSlot = pdp.querySelector('[data-fountain-gallery-main]');
    if (!mainSlot) return;
    var img = mainSlot.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      mainSlot.innerHTML = '';
      mainSlot.appendChild(img);
    }
    img.src = src;
    img.alt = alt;
    pdp.querySelectorAll('[data-fountain-thumb]').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  // ---- Sticky mobile ATC ----
  function initStickyAtc() {
    var sticky = document.querySelector('[data-fountain-sticky-cta]');
    var primary = document.querySelector('[data-fountain-cta]');
    if (!sticky || !primary) return;
    if (!('IntersectionObserver' in window)) {
      // Old browser fallback: show only after a scroll event past the CTA's top
      window.addEventListener('scroll', function () {
        var rect = primary.getBoundingClientRect();
        if (rect.bottom < 0) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      }, { passive: true });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Only show sticky when the primary CTA has scrolled ABOVE the viewport,
        // i.e. user is below the CTA. Don't show when CTA is below the fold
        // (initial page load, user hasn't scrolled there yet).
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          sticky.classList.add('is-visible');
        } else {
          sticky.classList.remove('is-visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(primary);
  }

  // ---- ATC click capture — runs BEFORE any third-party cart drawer (UPCART, etc.)
  // intercepts the click, builds multi-item payload, posts to /cart/add.js,
  // and navigates to /cart. Falls through to native form submit if no add-ons.
  // ---- ATC click handler (called from inline onclick, fires BEFORE UPCART) ----
  // Returning false from the inline onclick prevents any addEventListener handler
  // (including UPCART's) from firing. We build a cart permalink and navigate.
  window.fountainAtc = function (triggerEl) {
    try {
      var pdp = triggerEl.closest('[data-fountain-pdp]') || triggerEl.closest('.fountain-scope');
      if (!pdp) return false;
      var form = pdp.querySelector('[data-fountain-form]');
      if (!form) return false;

      var mainIdInput = form.querySelector('[name="id"]');
      if (!mainIdInput || !mainIdInput.value) return false;
      var mainId = parseInt(mainIdInput.value, 10);
      if (!mainId) return false;

      var visibleSet = pdp.querySelector('[data-fountain-bundles]:not([hidden])');
      var selectedBundle = visibleSet ? (visibleSet.querySelector('[data-fountain-bundle].is-selected') || visibleSet.querySelector('[data-fountain-bundle]')) : null;
      var currentTier = selectedBundle ? (selectedBundle.getAttribute('data-tier') || '') : '';

      var addonItems = [];
      pdp.querySelectorAll('[data-fountain-addon-checkbox]').forEach(function (cb) {
        if (!cb.checked) return;
        var label = cb.closest('.fountain-addon');
        if (!label) return;
        if (label.getAttribute('data-fountain-addon-visual-only') === 'true') return;
        var paidVid = parseInt(label.getAttribute('data-fountain-addon-variant') || '', 10) || null;
        var freeVid = parseInt(label.getAttribute('data-fountain-addon-free-variant') || '', 10) || null;
        var freeTiers = (label.getAttribute('data-fountain-addon-free-tiers') || '')
          .split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var useFree = freeVid && freeTiers.length > 0 && freeTiers.indexOf(currentTier) >= 0;
        var vid = useFree ? freeVid : paidVid;
        if (!vid) return;
        addonItems.push({ id: vid, quantity: 1 });
      });

      var pairs = [mainId + ':1'];
      addonItems.forEach(function (it) { pairs.push(it.id + ':' + it.quantity); });
      var url = '/cart/' + pairs.join(',') + '?return_to=/checkout';

      pdp.querySelectorAll('[data-fountain-cta], [data-fountain-sticky-submit]').forEach(function (b) {
        b.setAttribute('disabled', '');
        b.classList.add('is-disabled');
      });

      window.location.href = url;
    } catch (err) {
      console.error('[Fountain ATC]', err);
    }
    return false;
  };



    // ---- Addon checkbox change → recompute total ----
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-fountain-addon-checkbox]');
    if (!cb) return;
    var pdp = cb.closest('[data-fountain-pdp]') || cb.closest('.fountain-scope');
    if (pdp) fountainUpdateTotal(pdp);
  });

  // Sticky CTA click - submit main form
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fountain-sticky-submit]');
    if (!btn) return;
    var form = document.querySelector('form.fountain-form');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  // ---- Carousel (per PDP gallery) ----
  function initCarousel(carousel) {
    if (!carousel || carousel.__fountainCarouselInit) return;
    carousel.__fountainCarouselInit = true;

    var pdp = carousel.closest('.fountain-scope') || carousel.parentElement;
    if (!pdp) return;

    var slides = carousel.querySelectorAll('.fountain-gallery__slide');
    var thumbs = pdp.querySelectorAll('[data-fountain-thumb-index]');
    var arrows = pdp.querySelectorAll('[data-fountain-arrow]');
    if (!slides.length) return;

    function setActiveIndex(idx, allowScrollIntoView) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var activeThumb = pdp.querySelector('[data-fountain-thumb-index="' + idx + '"]');
      if (activeThumb) {
        activeThumb.classList.add('is-active');
        // Only scroll the thumb strip when the change came from a user action.
        // On initial render this would yank the WHOLE PAGE down to bring the
        // thumb into view (since scrollIntoView affects every ancestor scroller).
        if (allowScrollIntoView) {
          try {
            // Use the thumb strip as the scroll container so we never move the page.
            var strip = activeThumb.parentElement;
            if (strip && typeof strip.scrollTo === 'function') {
              var left = activeThumb.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2;
              strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
            }
          } catch (e) {}
        }
      }
      arrows.forEach(function (a) {
        var dir = a.getAttribute('data-fountain-arrow');
        if (dir === 'prev') a.disabled = idx <= 0;
        else if (dir === 'next') a.disabled = idx >= slides.length - 1;
      });
    }

    // Thumb click → scroll carousel to that slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-fountain-thumb-index'), 10);
        var target = slides[idx];
        if (!target) return;
        carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActiveIndex(idx, true);
      });
    });

    // Arrow click
    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var dir = arrow.getAttribute('data-fountain-arrow');
        var w = carousel.clientWidth;
        var current = Math.round(carousel.scrollLeft / w);
        var next = dir === 'next' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        if (next >= slides.length) next = slides.length - 1;
        var target = slides[next];
        if (target) {
          carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          setActiveIndex(next, true);
        }
      });
    });

    // Sync active thumb + arrow states as user scrolls/swipes
    var rafId = null;
    carousel.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var w = carousel.clientWidth;
        var idx = Math.round(carousel.scrollLeft / w);
        if (idx >= 0 && idx < slides.length) setActiveIndex(idx);
      });
    });

    // Mouse drag-to-scroll (desktop)
    var isDown = false, startX = 0, startScroll = 0, hasDragged = false;
    carousel.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      startX = e.pageX - carousel.offsetLeft;
      startScroll = carousel.scrollLeft;
      carousel.classList.add('is-dragging');
    });
    carousel.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      carousel.classList.remove('is-dragging');
      snapToNearest();
    });
    carousel.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      carousel.classList.remove('is-dragging');
      snapToNearest();
    });
    carousel.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      var walk = (x - startX);
      if (Math.abs(walk) > 5) hasDragged = true;
      carousel.scrollLeft = startScroll - walk;
    });
    function snapToNearest() {
      var w = carousel.clientWidth;
      var idx = Math.round(carousel.scrollLeft / w);
      var target = slides[idx];
      if (target) carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    setActiveIndex(0);
  }

  // ---- Init non-event behaviour ----
  function boot() {
    initStickyAtc();
    document.querySelectorAll('.fountain-scope [data-fountain-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-fountain-pdp]').forEach(function (pdp) {
      fountainSyncVariantToggle(pdp);
      fountainUpdateTotal(pdp);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();





/* re-sync trigger: 1779109268 */














